import { Options } from 'highcharts';
import {
  getDefaultChartOptions,
  getDefaultScrollBarOptions,
  getDefaultTooltipOptions,
} from './utils';

export const getProjectByInferredProgressOptions = (
  initialOptions?: Options,
): Options => ({
  ...initialOptions,
  chart: { ...getDefaultChartOptions(), height: initialOptions?.chart?.height },
  tooltip: {
    ...getDefaultTooltipOptions(),
    ...initialOptions?.tooltip,
    headerFormat: '',
  },
  plotOptions: {
    ...initialOptions?.plotOptions,
    column: {
      ...initialOptions?.plotOptions?.column,
      grouping: false,
    },
  },
  title: initialOptions?.title,
  xAxis: initialOptions?.xAxis,
  yAxis: initialOptions?.yAxis,
  series: initialOptions?.series,
  scrollbar: {
    ...getDefaultScrollBarOptions(),
  },
});
